import React from "react";
import "./BlogCard.css";
import { Card, CardActionArea, CardContent, CardMedia, Container, Typography } from "@mui/material";
import { StyledTooltip } from "../StyledComponents/StyledTooltip/StyledTooltip";

import { useNavigate } from "react-router-dom";
import { AxiosError, AxiosResponse } from "axios";
import { serviceFetchBlogsUrlPath } from "../../../api/service/services";

type Props = {
  id: string;
  cardBG: string;
  title: string;
  blogName: string;
  blogUrl: string;
};

const BlogCard: React.FC<Props> = (props) => {
  const navigate = useNavigate();

  const handleCardClick = async () => {
    await serviceFetchBlogsUrlPath(props.id)
      .then((response: AxiosResponse) => {
        const blogData = response.data;
        navigate(`/blogs/${props.blogName}`, {
          state: {
            title: blogData.title.rendered,
            content: blogData.content.rendered,
          },
        });
      })
      .catch((error: AxiosError<any>) => {
        console.error("Error fetching blog data:", error);
      });
  };

  return (
    <Container
      maxWidth={"xs"}
      sx={{
        bgcolor: "#FCFCFC",
        borderRadius: "14px",
        boxShadow: `0px 1px 4px 0px #00000040, 0px 0px 4px 0px #0000001A inset`,
        p: {xs:2,sm:2,md:2.5,xl:1.5},
        width: "230px",
      }}
    >
      <Card
        id={`blog-${props?.id}`}
        variant="outlined"
        sx={{
          borderRadius: "10px",
          overflow: "hidden",
          minWidth: "188px",
          height: "auto",
          border: 0,
          "&:hover": {
            backgroundColor: "rgba(255, 255, 255)",
          },
        }}
        onClick={handleCardClick}
      >
        <CardActionArea>
          {/* Image Section */}
          <CardMedia
            component="img"
            height="148"
            image={props?.cardBG}
            alt={props?.title}
            sx={{
              objectFit: "unset",
            }}
          />

          {/* Title Section */}
          <CardContent sx={{ p: 1 }}>
            <Typography
              variant="body2"
              sx={{
                fontWeight: 600,
                textAlign: "center",
                fontSize: "0.9rem",
                color: "#333",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
              title={props?.title}
            >
              {props?.title}
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    </Container>
  );
};

export default BlogCard;
